import * as React from 'react';

import './AccordionSection.scss';

interface IAccordionSectionProps {
  children: any;
  isOpen: boolean;
  identifier: string;
  header: any;
  onClick: (label: string) => void;
}

class AccordionSection extends React.Component<IAccordionSectionProps, any> {
  private handleClick = () => {
    this.props.onClick(this.props.identifier);
  };

  public render() {
    return (
      <div className="rp-accordion-section">
        <div
          className="rp-accordion-section--header"
          onClick={this.handleClick}
        >
          {this.props.header}
          {!this.props.isOpen && <span className="rpds-expand-more" />}
          {this.props.isOpen && <span className="rpds-expand-less" />}
        </div>
        {this.props.isOpen && (
          <div className="rp-accordion-section--expandable">
            {this.props.children}
          </div>
        )}
      </div>
    );
  }
}

export default AccordionSection;
